import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Input as RebassInput } from "@rebass/forms";

const InputStyle = styled(RebassInput)`
  color: ${props => props.color};
  background-color: transparent;
  outline: none;
  padding: 10px;
  border: 1px solid;
  border-color: ${props => props.color};
  resize: none;
  line-height: 1.4;
  transition: border 0.5s ease-out, color 0.5s ease-out;
  opacity: 0.5;
  ::placeholder {
    color: ${props => props.color};
  }
  :focus {
    color: ${props => props.focusColor};
    border: 1px solid ${props => props.focusColor};
    opacity: 1;
    ::placeholder {
      color: transparent;
      opacity: 1;
    }
  }
`;

const Input = ({ children, ...props }) => (
  <InputStyle {...props}>{children}</InputStyle>
);

Input.propTypes = {
  children: PropTypes.node,
  color: PropTypes.node,
  focusColor: PropTypes.node
};

Input.defaultProps = {
  children: null,
  color: "rgba(255, 255, 255, 0.7)",
  focusColor: "white"
};

export default Input;
